import React from "react";

function Button(props) {
  const classes =
    props.classes === null ? "w-btn w-btn-white" : "w-btn " + props.classes;
  return (
    <>
      <button className={classes}> 
        {props.text} 
      </button>
    </>
  );
}

export default Button;
